module.exports = __webpack_public_path__ + "img/horizontal_3_1_r_pp1_6.8de50598.png";